import { render, staticRenderFns } from "./Beneficiaries.vue?vue&type=template&id=7949ac31"
import script from "./Beneficiaries.vue?vue&type=script&lang=js"
export * from "./Beneficiaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports